import BaseApi from './base.api';

export interface RegisterPatientRequest {
  egn: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  gender: 'MALE' | 'FEMALE';
  password: string;
}

export interface RegisterPatientResponse {
  userId: number;
  patientId: number;
  email: string;
  cognitoId: string;
  message: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  email: string;
  code: string;
  newPassword: string;
}

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

class AuthApi extends BaseApi {
  constructor() {
    super();
  }

  public registerPatient = (
    request: RegisterPatientRequest
  ): Promise<RegisterPatientResponse> => {
    return this.post('/auth/register', request);
  };

  public forgotPassword = (
    request: ForgotPasswordRequest
  ): Promise<{ message: string }> => {
    return this.post('/auth/forgot-password', request);
  };

  public resetPassword = (
    request: ResetPasswordRequest
  ): Promise<{ message: string }> => {
    return this.post('/auth/reset-password', request);
  };

  public changePassword = (
    request: ChangePasswordRequest
  ): Promise<{ message: string }> => {
    // Access token is now automatically sent in Authorization header by BaseApi
    return this.post('/auth/change-password', request);
  };
}

export const authApi = new AuthApi();
export const registerPatient = authApi.registerPatient;
export const forgotPassword = authApi.forgotPassword;
export const resetPassword = authApi.resetPassword;
export const changePassword = authApi.changePassword;
